import { useMemo } from "react";
import { WidgetsRuntimeSettings } from "@kaltura-corp/unisphere-plg-types";

export function usePlgWidgetSettings(ks: string): WidgetsRuntimeSettings {
    return useMemo<WidgetsRuntimeSettings>(
        () => ({
            ks,
            productType: "AVATAR_STUDIO",
        }),
        [ks]
    );
}
